import { addMethod, array, boolean, object, string, ObjectSchema, Schema } from 'yup';

import { ImpactValues } from '@buyside/util/ideaUpdateFormHelper';
import { Maybe } from '@interfaces/graphql-typings';

addMethod(string, 'isValidPriceTarget', function(openingPrice, direction): Schema<any> {
  return this.test({
    name: 'isValidPriceTarget',
    message: 'Please enter a valid price target according to the initial price and direction',
    test(value): boolean {
      if (!openingPrice) return true;
      const numValue = parseFloat(value.replace(/,/g, ''));
      return direction === 'long' ? numValue > openingPrice : numValue < openingPrice;
    }
  });
});

addMethod(string, 'isValidNumber', function(): Schema<any> {
  return this.test({
    name: 'isValidNumber',
    message: 'Please enter a valid number',
    test(value): boolean {
      return !Number.isNaN(parseFloat(value.replace(/,/g, '')));
    }
  });
});

export const ideaUpdateFormValidationSchema = (
  openingPrice: Maybe<number>,
  direction: string,
  isPairTrade: boolean
): ObjectSchema =>
  object().shape({
    attachments: array().of(
      object({
        filename: string().required('Please select a file'),
        researchType: string().required('Please select a research type'),
        attachmentType: string().required('Please select an attachment type')
      })
    ),
    closeIdea: boolean(),
    impact: string().when('closeIdea', {
      is: true,
      then: string()
        .nullable()
        .notRequired(),
      otherwise: string()
        .oneOf([ImpactValues.POSITIVE, ImpactValues.NEUTRAL, ImpactValues.NEGATIVE])
        .required('Please select an option')
    }),
    priceTarget: isPairTrade
      ? string().nullable()
      : string()
          .isValidNumber()
          .isValidPriceTarget(openingPrice, direction),
    returnTarget: isPairTrade ? string().isValidNumber() : string().nullable()
  });
